import React from 'react';
import Layout from '../components/Layout';
import UserList from '../components/UserList';

/**
 * Página de listado de usuarios
 * Utiliza el componente Layout para la estructura básica
 * y el componente UserList para mostrar la lista de usuarios
 */
const Users = () => {
  return (
    <Layout>
      <div>
        <UserList />
      </div>
    </Layout>
  );
};

export default Users;